export default function PageHeader({ title }: { title: string }) {
  return <h2 className="my-1 text-xl font-light">{title}</h2>
}
